export default __webpack_public_path__ + "4874eca.png";